const defaultMessages = {
  'accessdenied': {
    title: 'Access Denied',
    message: `
      <p>You do not have premission to store credit card details.</p>
      <p>
        Please contact the site admin for further assistance.
      </p>
    `
  },
  'transaction-paid': {
    title: 'Transaction Paid',
    message: `
      <p>The transaction has already been marked as paid.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-cancelled': {
    title: 'Transaction Cancelled',
    message: `
      <p>You cannot pay a cancelled transaction.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-refunded': {
    title: 'Transaction Refunded',
    message: `
      <p>You cannot pay a refunded transaction.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-failed': {
    title: 'Transaction Failed',
    message: `
      <p>You cannot pay a failed transaction.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-denied': {
    title: 'Transaction Denied',
    message: `
      <p>The transaction has been locked by the site admin.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-notfound': {
    title: 'Transaction Not Found',
    message: `
      <p>The transaction requested could not be located.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'transaction-received': {
    title: 'Transaction Payment Received',
    message: `
      <p>The transaction payment has been recieved but funds not yet cleared.</p>
      <p>
        Please check that you have selected the correct invoice to be paid, and contact the
        site admin for further information.
      </p>
    `
  },
  'ratelimit-exceeded': {
    title: 'Too Many Payment Requests',
    message: `
      <p>The system has detected that you are making too many payment request in too short a period of time.</p>
      <p>To protected the system for attackers and fraudlent credit card transactions, we limit the number of
      payment request that you can make in a specific period of fime.</p>
      <p>Please wait some time before making further payment requests.</p>
      <p>If the problem persists please contact the site admin, for further assistance.</p>
    `
  }
}

export default function(category) {
  if (defaultMessages[category] === undefined) {
    return defaultMessages['transaction-failed']
  }
  return defaultMessages[category]
}
